const MODULE = 'AXES_LAYER'

export const FETCH_AXES_SUCCESS = `${MODULE}/FETCH_AXES_SUCCESS`
export const FETCH_AXES_REQUEST = `${MODULE}/FETCH_AXES_REQUEST`
export const FETCH_AXES_FAILED = `${MODULE}/FETCH_AXES_FAILED`